import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    const onPage = document.querySelector(href);
    if (onPage) {
      e.preventDefault();
      onPage.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      setIsMobileMenuOpen(false);
      return;
    }
    if (window.location.pathname !== '/') {
      window.location.assign(`/${href}`);
      setIsMobileMenuOpen(false);
      return;
    }
    e.preventDefault();
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { href: '#chi-siamo', label: 'Chi siamo' },
    { href: '#servizi', label: 'Servizi' },
    { href: '#contatti', label: 'Contatti' },
    { href: '/siti', label: 'Siti e gestione', page: true },
    { href: '/affiliate', label: 'Affiliazione', page: true },
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container nav-container">
        <a href="/" className="nav-logo">
            <img src="/media/3LT_Logo.png" alt="Tre Lune" height="32" />
            <span>Tre Lune</span>
        </a>

        <button 
            className="mobile-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
            {isMobileMenuOpen ? '✕' : '☰'}
        </button>

        <div className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
            {navLinks.map((link) => (
                link.page ? (
                    <Link
                        key={link.label}
                        to={link.href}
                        className="nav-link"
                        aria-current={location.pathname === link.href ? 'page' : undefined}
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        {link.label}
                    </Link>
                ) : (
                    <a
                        key={link.label}
                        href={link.href}
                        className="nav-link"
                        onClick={(e) => handleNavClick(e, link.href)}
                    >
                        {link.label}
                    </a>
                )
            ))}
            <a 
                href="#contatti" 
                className="btn btn-primary nav-cta"
                onClick={(e) => handleNavClick(e, '#contatti')}
            >
                Avvia il progetto
            </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
